import View from "../../../Account/Js/views/AccordionView";
import components from "./components.js";
components.define("js-Accordion", View);